import React, { Component } from 'react';
export default class CarouselArrow extends Component {
  render() {
    if (this.props.slides && this.props.slides.length < 2) {
      return null;
    }

    if (this.props.arrow === 'previous') {
      return (
        <div className="carousel-arrow-previous" onClick={this._onPrev}>
          &lsaquo;
        </div>
      );
    }
    if (this.props.arrow === 'next') {
      return (
        <div className="carousel-arrow-next" onClick={this._onNext}>
          &rsaquo;
        </div>
      );
    }
  }

  _onPrev = () => {
    this.props.slider.slickPrev();
  };

  _onNext = () => {
    this.props.slider.slickNext();
  };
}
